import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", null, [
      _createElementVNode("path", {
        d: "M7.55556 6.44444V2M16.4444 6.44444V2M6.44444 10.8889H17.5556M4.22222 22H19.7778C21.0051 22 22 21.0051 22 19.7778V6.44444C22 5.21715 21.0051 4.22222 19.7778 4.22222H4.22222C2.99492 4.22222 2 5.21715 2 6.44444V19.7778C2 21.0051 2.99492 22 4.22222 22Z",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      })
    ], -1)
  ]))]))
}
export default { render: render }